import { useMemo, useState } from 'react';

import { Field, NativeSelect, useSlotRecipe } from '@chakra-ui/react';

import isNil from 'lodash/isNil';

import {
    defaultGuestsPickerConfig,
    defaultGuestsPickerTranslation,
    wordPluralisation,
} from '@nocowanie/common-ui';

import { GuestPickerSelectProps } from './guest-picker-select.props';

export const GuestPickerSelect = ({
    value,
    max = defaultGuestsPickerConfig.childAgeItemConfig.max as number,
    label,
    placeholder,
    isRequired = true,
    onChange,
    'data-testid': testId,
}: GuestPickerSelectProps) => {
    const [age, setAge] = useState(value);
    const recipe = useSlotRecipe({
        key: 'guestsPickerSelect',
    });
    const styles = recipe();

    const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAge = event.target.value;
        if (newAge === age || newAge === '') {
            return;
        }

        setAge(newAge);
        onChange && onChange(newAge, parseInt(newAge));
    };

    const ageOptions = useMemo(() => {
        const { singular, plural, genitivePlural } = defaultGuestsPickerTranslation.ageLabel;

        const getGuestLabel = (count: number) =>
            wordPluralisation(count, singular, plural, genitivePlural);

        return [...Array(max + 1).keys()].map(age => (
            <option
                key={age}
                value={age}
                style={{
                    color: 'gray.950',
                }}
            >
                {age} {getGuestLabel(age)}
            </option>
        ));
    }, [max]);

    return (
        <Field.Root required={isRequired} asChild>
            <NativeSelect.Root className="wc-guestpicker-select">
                <NativeSelect.Field
                    value={isNil(age) ? '' : age}
                    onChange={handleOnChange}
                    color={isNil(value) ? '{colors.placeholder}' : undefined}
                    data-testid={testId}
                >
                    <option hidden disabled value="">{`${placeholder} ${label}`}</option>
                    {ageOptions}
                </NativeSelect.Field>
                <NativeSelect.Indicator {...styles.icon} />
            </NativeSelect.Root>
        </Field.Root>
    );
};
